module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/team/team.component.css
// module id = ./src/app/team/team.component.css
// module chunks = main